import React from 'react'
import PropTypes from 'prop-types'
import { Box, Paper } from '@material-ui/core'
import Table from '../../components/Tables/Table'
import TableCell from '../../components/Tables/TableCell'
import TableRow from '../../components/Tables/TableRow'
import Pagination from '../../components/Tables/Pagination'
import { usePagination } from '../../components/Tables/Pagination.hooks'
import Typography from '../../components/Basics/Typography'
import { getHealthState } from './healthStatus'

const StateChip = ({ value }) => {
  const state = getHealthState(value)
  return (
    <span
      style={{
        padding: '2px 8px',
        borderRadius: '10px',
        fontSize: '11px',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
        backgroundColor: state.color,
        color: state.text
      }}
    >
      {state.label}
    </span>
  )
}

StateChip.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

const formatReasons = razones => {
  if (Array.isArray(razones)) return razones.join(' · ')
  return String(razones || '').replace(/,\s*/g, ' · ')
}

/**
 * The HealthTransitionsTable's component (view "Transiciones registradas").
 * State changes from the rolling 7-day log, newest first.
 */
const HealthTransitionsTable = ({ salud }) => {
  const transitions = [...(salud.transiciones || [])].reverse()

  const { page, totalPages, onChangePage, onGetCurrentPage } = usePagination({
    data: transitions,
    initialPage: 1,
    rowsPerPage: 15
  })

  return (
    <Box style={{ marginTop: '30px' }}>
      <Typography variant="h2" margin="0 0 10px 0">
        Transiciones registradas (últimos 7 días)
      </Typography>
      <Paper style={{ overflow: 'auto' }}>
        {transitions.length === 0 ? (
          <Typography variant="body1" margin="15px" color="gray">
            Sin transiciones en los últimos 7 días
          </Typography>
        ) : (
          <>
            <Table accesibility={{ label: 'HealthTransitions' }}>
              <TableRow head>
                <TableCell>Fecha</TableCell>
                <TableCell>Camión</TableCell>
                <TableCell>Transición</TableCell>
                <TableCell>Razones</TableCell>
              </TableRow>

              {onGetCurrentPage().map((row, index) => (
                <TableRow key={`transition-${index}`}>
                  <TableCell align="center" minWidth="150px">
                    {row.fecha}
                  </TableCell>
                  <TableCell align="center" minWidth="100px">
                    {row.equipo}
                  </TableCell>
                  <TableCell align="center" minWidth="200px">
                    <StateChip value={row.antes} /> → <StateChip value={row.ahora} />
                  </TableCell>
                  <TableCell align="left" minWidth="250px">
                    {formatReasons(row.razones)}
                  </TableCell>
                </TableRow>
              ))}
            </Table>
            <Pagination alignment="right" count={totalPages} page={page} onChange={onChangePage} />
          </>
        )}
      </Paper>
    </Box>
  )
}

HealthTransitionsTable.propTypes = {
  salud: PropTypes.object.isRequired
}

export default HealthTransitionsTable
